import { axiosInstance } from './api';
import type { Paginated } from './types';

export interface ShelfDto {
  id: string;
  area: string;
  rack: string;
  name: string;
  bottom_points_indices: number[];
  top_points_indices: number[];
  perspective_width: number;
  perspective_height: number;
  empty_shelf_score: number;
  shelf_num_on_rack: number;
  max_effective_percentage: number;
}

export interface ShelfCreateDto {
  area: string;
  rack: string;
  name: string;
  bottom_points_indices: number[];
  top_points_indices: number[];
  perspective_width?: number | null;
  perspective_height?: number | null;
  empty_shelf_score?: number | null;
  shelf_num_on_rack?: number | null;
  max_effective_percentage?: number | null;
  /** Поправка модели — делитель сырого процента (AI197). */
  model_correction_max_pct?: number | null;
  /** Модель ЭТОЙ полки: null = как у стеллажа, true = процентная, false = количественная (AI192/AI197). */
  predict_percentage?: boolean | null;
  /** Тип продукции полки поверх стеллажа; null — как у стеллажа (#3288). */
  rack_type?: string | null;
}

export type ShelfPatchDto = Partial<ShelfCreateDto>;

export const listShelvesByAreas = (areaIds: string[], pageSize = 1000) => {
  if (!areaIds || areaIds.length === 0) {
    return Promise.resolve({ data: { results: [] as ShelfDto[] } } as { data: Paginated<ShelfDto> });
  }
  const ids = areaIds.join(',');
  return axiosInstance.get<Paginated<ShelfDto>>(`/empty_shelf/shelf/?area__in=${ids}&page_size=${pageSize}`);
};

export const createShelf = (payload: ShelfCreateDto) => {
  return axiosInstance.post<ShelfDto>('/empty_shelf/shelf/', payload);
};

export const patchShelf = (shelfId: string, payload: ShelfPatchDto) => {
  return axiosInstance.patch<ShelfDto>(`/empty_shelf/shelf/${shelfId}/`, payload);
};

/** keepArea — смена типа: снять только сущность, полигон оставить (#3222). */
export const deleteShelf = (shelfId: string, keepArea = false) => {
  return axiosInstance.delete(`/empty_shelf/shelf/${shelfId}/`, keepArea ? { params: { keep_area: 1 } } : undefined);
};
